import moment from 'moment';

moment.updateLocale('en', { utcOffset: 0 });

export default moment;
